import { render, staticRenderFns } from "./ServiceObjectMaintenanceNoteBody.vue?vue&type=template&id=17eb8652&"
import script from "./ServiceObjectMaintenanceNoteBody.vue?vue&type=script&lang=js&"
export * from "./ServiceObjectMaintenanceNoteBody.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QCardSection,QItem,QList,QItemSection,QItemLabel,QInput,QIcon,QField,QBtn} from 'quasar'
component.options.components = Object.assign({QCardSection,QItem,QList,QItemSection,QItemLabel,QInput,QIcon,QField,QBtn}, component.options.components || {})
